import qs, {parse, stringify, parseUrl} from 'query-string'
export default {
    ...qs,
    parseUrl,
    stringifyUrl: ({
        url,
        query,
        encode = true,
        nomalizeUrl = false,
    }: {
        url: string
        query: Record<string, unknown>
        encode?: boolean
        nomalizeUrl?: boolean
    }): string => {
        const queryString = stringify(query, {encode})

        if (!queryString) {
            return url
        }

        // ?가 포함된 url 가공할 경우
        if (nomalizeUrl) {
            const [pureUrl, extraQueries] = url.split('?')

            if (extraQueries) {
                return `${pureUrl}?${extraQueries}&${queryString}`
            }
        }

        return `${url}?${queryString}`
    },
    // extract와 반대개념
    inject: ({url, query}: {url: string; query: Record<string, unknown>}): string => {
        // hash값은 뒤로 떼어둔다
        const [hashExcluded = '', hashQuery] = url.split('#')
        const [urlOrigin, urlSearch = ''] = hashExcluded.split('?')
        // ?가 들어간 이상 query는 무시한다
        const currentQuery = parse(urlSearch)
        const currentHash = hashQuery ? `#${hashQuery}` : ''

        return `${urlOrigin}?${stringify({...currentQuery, ...query})}${currentHash}`
    },
    stringifyUrlBySort: <T extends object>({url, query, sorts}: {url: string; query: T; sorts: (keyof T)[]}) => {
        const result = sorts.reduce(
            (acc, key) => {
                if (query[key]) {
                    const keyText = String(key)
                    return {
                        url: `${acc.url}${acc.hasQuery ? '&' : '?'}${keyText}=${encodeURIComponent(
                            String(query[key]),
                        )}`,
                        queryString: acc.queryString.filter((v) => {
                            return !v.startsWith(`${keyText}=`)
                        }),
                        hasQuery: true,
                    }
                }
                return acc
            },
            {
                url,
                queryString: stringify(query).split('&'),
                hasQuery: false,
            },
        )
        if (result.queryString.length) {
            return `${result.url}${result.hasQuery ? '&' : '?'}${result.queryString.join('&')}`
        }
        return result.url
    },
}
